import { configureStore } from "@reduxjs/toolkit";
import productListReducer from "../pages/productLists/productListSlice";
import appReducer from "./appSlice";
import sharedDataReducer from "../pages/sharedData/sharedDataSlice";
import addProductWizardReducer from "../pages/productLists/AddProductWizard/AddProductWizardSlice";
import reviewSharedDataReducer from "../pages/reviewSharedData/reviewSharedDataSlice";
import userManagementReducer from "../pages/userManagement/userManagementSlice";

export default configureStore({
  reducer: {
    productList: productListReducer,
    app: appReducer,
    sharedData: sharedDataReducer,
    addProductWizard: addProductWizardReducer,
    reviewSharedData: reviewSharedDataReducer,
    userManagement: userManagementReducer
  },
});
